// src/utils/authHelpers.ts
import { CognitoUserPool } from 'amazon-cognito-identity-js';

// Define your Cognito User Pool
const poolData = {
  UserPoolId: 'us-east-1_x4S7fF5Nl', // Replace with your User Pool ID
  ClientId: '16jnkpde2qggp492jqn5vhkpoq', // Replace with your App Client ID
};

const userPool = new CognitoUserPool(poolData);

// Function to retrieve the current session
export async function getUserSessionTokens() {
  try {
    // Get the current logged-in user
    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser == null) {
      throw new Error('No user is currently logged in.');
    }

    // Get the session (this retrieves the JWT tokens)
    const session = await new Promise((resolve, reject) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err);
        } else {
          resolve(session);
        }
      });
    });

    // Extract the tokens
    const accessToken = session.getAccessToken().getJwtToken();
    const idToken = session.getIdToken().getJwtToken();

    return { accessToken, idToken };
  } catch (error) {
    console.error('Error retrieving tokens:', error);
  }
}
